import { http } from 'helpers/axios';
import { compose, lifecycle, withState } from 'recompose';

import PushApiLog from '../components/PushApiLog';

const enhance = compose(
  withState('pushEvent', 'setPushEvent', null),
  lifecycle({
    componentDidMount() {
      http
        .get('/sportsapi/info', {
          params: { id: this.props.api._id },
        })
        .then(res => this.props.setPushEvent(res.data))
        .catch(err => console.log(err));
    },
  })
);

export default enhance(PushApiLog);
